export const permissionsKeys = {
  page: 'param.themes',
  pageBlockUpdate: 'param.themes.page-version.update',
} as const;
